export default "__VITE_ASSET__CfwHr0WI__"